
import { EmailCapture } from "../EmailCapture";
import { GameHeader } from "../GameHeader";

interface EmailSectionProps {
  onEmailComplete: (email: string) => void;
}

export function EmailSection({ onEmailComplete }: EmailSectionProps) {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-6 flex flex-col items-center">
        <GameHeader />
        <div className="w-full max-w-md mt-2">
          <EmailCapture onComplete={onEmailComplete} />
        </div>
      </div>
    </div>
  );
}
